<template>
  <div id="cases_detail">
    <TabBar />
    <div class="detail_banner"></div>
    <div class="container">
      <div class="home_item_content">
        <h1>销售大神</h1>
        <i></i>
        <h6>用户体验/移动平台开发</h6>
      </div>
      <div class="detail_txt">
        <h3>项目简介</h3>
        <h5>以快速成交为目的的销售神器</h5>
        <p>销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息，我们只有一个目标：让销售快速成交！</p>
        <p>销售业绩是企业的命脉。不管你是虚拟的线上产品，还是实体线下产业，最终如何把产品市场化，锁定重点有效客户，达成交易，是每一个企业关注的。</p>
        <p>天下武功，唯快不破。销售战略讲究抢占先机，精准把控市场。销售大神这款APP，重在“快速”俩字。快速匹配目标客户 → 快速建立沟通通道 → 快速抢占重点资源。</p>
        <p>本着服务中小企业销售业绩快速增涨的研发初心，我们决定在未来3个月内，对新入驻的企业，免费送出1个月的VIP尊贵服务体验，现在注册，即可领取。</p>
      </div>
      <div class="detail_img">
        <img src="../assets/images/sell_img.png" alt />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail_banner {
  background: url("../assets/images/sell-banner.png") no-repeat;
  background-position: center;
  height: 500px;
  position: relative;
  top: 90px;
  z-index: -1;
  min-width: 1200px;
}
.container {
  width: 1200px;
  margin: -250px auto 0;

  .home_item_content {
    color: #ffffff;
    margin-bottom: 145px;
    h6 {
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
    }
    i {
      display: block;
      height: 4px;
      width: 40px;
      background-color: #ffffff;
      margin: 8px 0;
    }
    h1 {
      font-size: 36px;
      line-height: 50px;
      font-weight: 500;
    }
  }
  .detail_txt {
    width: 1200px;
    height: 238px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
    padding: 30px;
    h3 {
      line-height: 28px;
      font-size: 20px;
      color: rgba(38, 172, 255, 1);
    }
    h5 {
      font-size: 16px;
      line-height: 22px;
      margin: 20px 0 10px 0;
    }
    p {
      padding: 0 20px;
      line-height: 24px;
      font-size: 14px;
    }
  }
  .detail_img {
    margin: 60px 0 100px 0;
  }
}
</style>